import React, { useState, useEffect, useRef } from "react"
import SocialShare from "@/components/SocialShare/v1/SocialShare"
import { sanitizeInnerHtml } from "@/utils/helper"
import printIcon from "@/public/icons/print.svg"
import shareIcon from "@/public/icons/share.svg"
import {
  getTabContentEventInfo,
  handleContactDataLayer,
  handleViewDataLayer,
} from "@/components/PressRoomLanding/v1/pressRoomAnalytics"
import { getEventInfo } from "@/components/PressRoomLanding/v1/pressRoomAnalytics"
import { useRouter } from "next/router"

const TabContent = ({
  analyticsLabel = "",
  i18n = {},
  pressContact = [],
  productPlacement = [],
  tabData = {},
}) => {
  const contactRef = useRef(null)
  const contactRef1 = useRef(null)
  const sortBtn = useRef(null)
  const shareImg = useRef(null)
  const [showSocialLink, setShowSocialLink] = useState(false)
  const [contactList, setContactList] = useState([])
  const [placementList, setPlacementList] = useState([])
  const [viewContactList, setViewContactList] = useState(false)
  const [hideContactList, setHideContactList] = useState(false)
  const [viewPlacementList, setViewPlacementList] = useState(false)
  const [hidePlacementList, setHidePlacementList] = useState(false)
  const router = useRouter()

  useEffect(() => {
    if (!showSocialLink) {
      sortBtn.current?.focus()
    }
  }, [showSocialLink])

  useEffect(() => {
    const pressContactSize =
      pressContact.length > 5
        ? 3
        : pressContact.length === 5
        ? pressContact.length - 2
        : 3
    handleContactList(pressContactSize)
    if (pressContact.length > 3) setViewContactList(true)
  }, [pressContact])

  useEffect(() => {
    const pressContactSize =
      productPlacement.length > 5
        ? 3
        : productPlacement.length === 5
        ? productPlacement.length - 2
        : 3
    handlePlacementList(pressContactSize)
    if (productPlacement.length > 3) setViewPlacementList(true)
  }, [productPlacement])

  const handleContactList = pressContactSize => {
    if (pressContact.length > 0) {
      const list = []
      pressContact.forEach((item, i) => {
        if (i < pressContactSize) {
          list.push(item)
        }
      })
      setContactList(list)
    }
  }

  const handlePlacementList = pressContactSize => {
    if (productPlacement.length > 0) {
      const list = []
      productPlacement.forEach((item, i) => {
        if (i < pressContactSize) {
          list.push(item)
        }
      })
      setPlacementList(list)
    }
  }

  useEffect(() => {
    if (placementList.length > 0) {
      if (contactRef.current) {
        const links = contactRef.current.querySelectorAll("a")
        links.forEach((link, i) => {
          link.classList.add("gbh-data-layer")
          const item = contactList[i] ?? {}
          link.setAttribute(
            "data-gbh-data-layer",
            getTabContentEventInfo(
              item?.phone,
              "contact number",
              item?.name?.toLowerCase(),
              analyticsLabel,
              item?.phone,
              i18n?.pressContact?.toLowerCase()
            )
          )
        })
      }
      if (contactRef1.current) {
        const links = contactRef1.current.querySelectorAll("a")
        links.forEach((link, i) => {
          link.classList.add("gbh-data-layer")
          const item = placementList[i] ?? {}
          link.setAttribute(
            "data-gbh-data-layer",
            getTabContentEventInfo(
              item?.phone,
              "contact number",
              item?.name?.toLowerCase(),
              analyticsLabel,
              item?.phone,
              i18n?.productPlacement?.toLowerCase()
            )
          )
        })
      }
    }
  }, [analyticsLabel, placementList, contactList])

  const handleContactListView = show => {
    if (show) {
      handleContactList(5)
      setViewContactList(false)
      setHideContactList(true)
    } else {
      handleContactList(3)
      setHideContactList(false)
      setViewContactList(true)
    }
  }

  const handlePlacementListView = show => {
    if (show) {
      handlePlacementList(5)
      setViewPlacementList(false)
      setHidePlacementList(true)
    } else {
      handlePlacementList(3)
      setHidePlacementList(false)
      setViewPlacementList(true)
    }
  }

  const handlePrint = () => {
    window.print()
  }

  const {
    ariaLabel: { email = () => {} },
    noContacts = "",
    viewMore = "",
    showLess = "",
    noProducts = "",
    print = "",
    share = "",
  } = i18n

  return (
    <div className="container kf-react-container press-room__tab-full-content">
      <div className="row">
        <div className="col-12 press-room__inner-container">
          <aside className="press-room__side_pannel">
            <div className="press-room__contact">
              <h2 className="press-room__contact_title">{i18n.pressContact}</h2>
              <div className="press-room__divider" />
              {
                <section role="group" aria-label={pressContact}>
                  {contactList.length > 0 &&
                    contactList.map((item, i) => (
                      <div key={i} className="press-room__contact_item">
                        <div className="press-room__contact_name">
                          {item.name}
                        </div>
                        <a
                          href={`mailto:${item.email}`}
                          aria-label={email(item.email, item.name)}
                          data-gbh-data-layer={getEventInfo(
                            `mailto:${item.email}`,
                            "email id",
                            "press contact"
                          )}
                          className="press-room__contact_email gbh-data-layer"
                        >
                          {item.email}
                        </a>
                        <div tabIndex="0">
                          <a
                            href={`tel:${item.phone}`}
                            className="press-room__contact_mobile gbh-data-layer"
                            data-gbh-data-layer={getEventInfo(
                              `${item.phone}`,
                              "contact number",
                              `${item.name.toLowerCase()}`,
                              `${item.phone}`,
                              `${pressContact}`
                            )}
                          >
                            {sanitizeInnerHtml(item.phone)}
                          </a>
                        </div>
                      </div>
                    ))}
                </section>
              }
              {contactList.length === 0 && (
                <div className="press-room__contact_item">
                  <div className="press-room__contact_name">{noContacts}</div>
                </div>
              )}
              {viewContactList && (
                <div
                  className="press-room__view_more --button gbh-data-layer"
                  tabIndex="0"
                  data-gbh-data-layer={handleViewDataLayer(analyticsLabel)}
                  onClick={() => handleContactListView(true)}
                >
                  {viewMore}
                </div>
              )}
              {hideContactList && (
                <div
                  className="press-room__view_more --button gbh-data-layer"
                  tabIndex="0"
                  data-gbh-data-layer={handleContactDataLayer(analyticsLabel)}
                  onClick={() => handleContactListView(false)}
                >
                  {showLess}
                </div>
              )}
            </div>

            <div className="press-room__placement">
              <h2 className="press-room__contact_title">
                {i18n.productPlacement}
              </h2>
              <div className="press-room__divider" />
              <section role="group" aria-label={i18n.productPlacement}>
                {placementList.length > 0 &&
                  placementList.map((item, i) => (
                    <div key={i} className="press-room__contact_item">
                      <div className="press-room__contact_name">
                        {item.name}
                      </div>
                      <a
                        href={`mailto:${item.email}`}
                        aria-label={email(item.email, item.name)}
                        data-gbh-data-layer={getEventInfo(
                          `mailto:${item.email}`,
                          "email id",
                          "product placement"
                        )}
                        className="press-room__contact_email gbh-data-layer"
                      >
                        {item.email}
                      </a>
                      <div tabIndex="0">
                        <a
                          href={`tel:${item.phone}`}
                          className="press-room__contact_mobile gbh-data-layer"
                          data-gbh-data-layer={getEventInfo(
                            `${item.phone}`,
                            "contact number",
                            `${item.name.toLowerCase()}`,
                            `${item.phone}`,
                            `${"Product Placement"}`
                          )}
                        >
                          {sanitizeInnerHtml(item.phone)}
                        </a>
                      </div>
                    </div>
                  ))}
              </section>
              {placementList.length === 0 && (
                <div className="press-room__contact_item">
                  <div className="press-room__contact_name">{noProducts}</div>
                </div>
              )}
              {viewPlacementList && (
                <div
                  className="press-room__view_more --button"
                  onClick={() => handlePlacementListView(true)}
                >
                  {viewMore}
                </div>
              )}
              {hidePlacementList && (
                <div
                  className="press-room__view_more --button"
                  onClick={() => handlePlacementListView(false)}
                >
                  {showLess}
                </div>
              )}

              <div
                className="press-room__contact-button-block"
                role="presentation"
              >
                <span
                  tabIndex="0"
                  className="press-room__print-block gbh-data-layer"
                  role="button"
                  aria-label={print}
                  data-gbh-data-layer={handleContactDataLayer(analyticsLabel)}
                  onClick={handlePrint}
                >
                  <img
                    aria-hidden
                    className="press-room__print-icon"
                    src={printIcon?.src}
                  />
                  <span aria-hidden className="press-room__print">
                    {print}
                  </span>
                </span>
                <span
                  className="press-room__share-block"
                  tabIndex="0"
                  onClick={() => setShowSocialLink(!showSocialLink)}
                  role="button"
                  aria-label={share}
                  ref={shareImg}
                >
                  <img
                    aria-hidden
                    className="press-room__share-icon"
                    src={shareIcon?.src}
                  />
                  <span
                    aria-hidden
                    className="press-room__share gbh-data-layer"
                    data-gbh-data-layer={getTabContentEventInfo(
                      "share",
                      "share",
                      "share",
                      analyticsLabel
                    )}
                  >
                    {share}
                  </span>
                </span>
                {showSocialLink ? (
                  <SocialShare
                    analyticData={{
                      eventAction: `press room:${analyticsLabel}:share`,
                      eventName: `press room:${analyticsLabel}:share`,
                      internalLinkPosition: "press room",
                      internalLinkType: "press room:share",
                      internalLinkZoneName: `press room:${analyticsLabel}:product placement`,
                    }}
                    showModal={showSocialLink}
                    id="kf-press-release"
                    onClose={() => {
                      setShowSocialLink(false)
                      shareImg?.current.focus()
                    }}
                    shareBtn={shareImg}
                    url={`${window.location.origin}${router?.asPath}`}
                  />
                ) : null}
              </div>
            </div>
          </aside>
          <div className="press-room__main_pannel">{tabData}</div>
        </div>
      </div>
    </div>
  )
}

export default TabContent
